module.exports = __webpack_public_path__ + "static/media/WM6@1.5x.0317280c.png";